import   Vue                    from 'vue';
import   Vuex                   from 'vuex';
import { messages,
         conversationSession }  from '../data-access';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    messages,
    conversationSession
    }
});
